/**
 * List of available font names used by menu rendering and editor UI.
 * Values must match Tailwind v4 `font-*` utilities generated from the
 * `--font-*` tokens declared in `src/index.css` `@theme inline`.
 *
 * Menu Points v2 typography:
 *  - work-sans        → body / UI default
 *  - all-round-gothic → brand display (headings)
 *  - system           → OS default (fallback)
 */
export const fonts = ['work-sans', 'all-round-gothic', 'system'] as const
